<div
    class="grid-container"
    [ngClass]="showBack() ? '-spread-content' : '-end'"
>
    @if (showBack()) {
        <div class="g-12 md:g-4">
            <button
                type="button"
                class="button -dark"
                (click)="this.prev.emit()"
            >
                Zurück
            </button>
        </div>
    }
    <div class="g-12 md:g-4 relative m-16:t md:m-0:t">
        @if (nextDisabled()) {
            <button
                type="submit"
                class="next"
                (click)="this.next.emit()"
                [disabled]="nextDisabled()"
                ctrlTooltip
                [ctrlTooltipConfig]="{ position: 'center-top', offsetY: 16 }"
            >
                Nächster Schritt
                <ctrl-tooltip class="invalid-tooltip">
                    {{ nextTooltip() }}
                </ctrl-tooltip>
            </button>
        } @else {
            <button
                type="submit"
                class="next"
                (click)="this.next.emit()"
                [disabled]="nextDisabled()"
            >
                Nächster Schritt
            </button>
        }
    </div>
</div>
